import clsx from 'clsx';

import { Spinner } from '@/components/ui/Spinner';

export interface PreloaderProps {
  size?: number;
  className?: string;
}

export function Preloader({ size = 40, className }: PreloaderProps) {
  return (
    <div className={clsx('fixed inset-0 z-9999 flex items-center justify-center bg-background/80 backdrop-blur-[2px] text-foreground', className)}>
      <Spinner size={size} thickness={3} />
    </div>
  );
}
